import { getPinDetail } from "./global";

/**
 * 获取搜索数据
 */
export function getPinDetailData(trackData: Record<string, any> = {}) {
  const pinDetailData = getPinDetail();
  trackData.pin_id = trackData.pin_id || pinDetailData.pin_id;
  trackData.board_id = trackData.board_id || pinDetailData.board_id;
  trackData.file_id = trackData.file_id || pinDetailData.file_id;
  trackData.content_type = trackData.content_type || pinDetailData.content_type;
  if (pinDetailData.ext) {
    Object.assign(trackData, pinDetailData.ext);
  }

  return trackData;
}
